export default __webpack_public_path__ + "static/media/3864.81b09bc4.png";